var version = {
    "name":      "dativery",
    "buildDateCode": "20260525-151838",
    "buildDate": "Mon May 25 2026 15:18:38 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260525-151838",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;